import {Component, Input, OnInit} from '@angular/core';
import {chartConfig, CommonConstant} from '../../app.constants';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'achoo-gauge-circle-chart',
  templateUrl: './achoo-gauge-circle-chart.component.html',
  styleUrls: ['./achoo-gauge-circle-chart.component.scss']
})
export class AchooGaugeCircleChartComponent implements OnInit {
  @Input() chartTitle: string | null;
  @Input() chartData: any[];
  @Input() chartBackgroundColor: string;
  @Input() height: number | 250;
  @Input() width: number;
  @Input() dataLabel: string;
  @Input() description: string | null;
  @Input() showInLegend: boolean | true;
  @Input() legendSymbolType: string | null;
  @Input() legendAlign: string | null;
  @Input() legendVerticalAlign: string | null;
  @Input() legendLayout: string | null;
  @Input() titlePosition = 'top';
  @Input() titleColor: string | '#95A0B1';
  @Input() spacingBottom: number;
  @Input() spacingTop: number;
  @Input() tooltipInfo: string;
  @Input() platformName: string;
  @Input() plotRounded = true;
  options: object;
  series: any[] = [];

  constructor(private pdfService: PdfExportService) {

  }

  ngOnInit() {
    this.chartData.forEach((data: any) => {
      this.series.push({
        name: data.name,
        data: [{
          color: data.lineColor,
          radius: chartConfig.gaugeChart.radius,
          innerRadius: chartConfig.gaugeChart.innerRadius,
          y: data.value,
        }],
        dataLabels: {
          enabled: false
        },
        showInLegend: this.showInLegend,
        lineWidth: 0
      });
    });

    this.options = {
      chart: {
        type: 'solidgauge',
        height: this.height,
        spacingTop: this.getConfigValue(this.spacingTop, chartConfig.gaugeChart.spacingTop),
        spacingBottom: this.getConfigValue(this.spacingBottom, chartConfig.gaugeChart.spacingBottom),
        borderRadius: 6,
        backgroundColor: this.getConfigValue(this.chartBackgroundColor, undefined)
      },

      title: {
        text: !this.platformName ? this.chartTitle : this.formatChartTitle(),
        verticalAlign: this.titlePosition === 'top' ? 'top' : 'bottom',
        y: this.titlePosition === 'top' ? chartConfig.gaugeChart.titlePositionTop : chartConfig.gaugeChart.titlePositionBottom,
        style: {
          color: chartConfig.defaultColor,
          fontSize: '1.2rem',
          textTransform: this.titlePosition === 'top' ? 'uppercase' : 'capitalize',
          whiteSpace: chartConfig.mobileTitleStyling.whiteSpace
        },
        useHTML: this.platformName ? true : false
      },
      tooltip: {
        enabled: false
      },
      credits: {
        enabled: false
      },

      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [{
          outerRadius: chartConfig.gaugeChart.radius,
          innerRadius: chartConfig.gaugeChart.paneInnerRadius,
          backgroundColor: chartConfig.gaugeChart.pannelBackgroundColor,
          borderWidth: 0
        }]
      },

      yAxis: {
        min: chartConfig.gaugeChart.yAxisMin,
        max: chartConfig.gaugeChart.yAxisMax,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: this.plotRounded
        }
      },
      legend: {
        align: this.legendAlign || CommonConstant.CHART_OPTIONS.LEGEND_ALIGN.RIGHT,
        verticalAlign: this.legendVerticalAlign || CommonConstant.CHART_OPTIONS.LEGEND_VERTICAL_ALIGN.TOP,
        layout: this.legendLayout || CommonConstant.CHART_OPTIONS.LEGEND_LAYOUT.VERTICAL,
        useHTML: true,
        labelFormatter: function () {
          let text = this.name;
          if (text.length > 20) {
            text = text.slice(0, 12) + '...';
          }

          return '<span class="d-flex flex-g1">'
                  + '<span class="d-flex flex-row flex-auto align-items-center justify-content-start highcharts-legend-item-content">'
                    + '<span class="d-flex legend-item-symbol" style="background-color: ' + this.points[0].color + ';"></span>'
                    + '<span class="d-flex legend-item-label text-light-font">' + text + ' ' + '</span>'
                    + '<span class="d-flex legend-item-value text-semi-bold-font">' + this.data[0].y + '%' + '</span>'
                  + '</span>'
                + '</span>';
          },
      },
      series: this.series,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 200
            },
            chartOptions: {
              chart: {
                height: 200,
                spacingBottom: 25,
                spacingTop: 20
              }
            },
          }
        ]
      }
    };
  }

  private formatChartTitle() {
    const titleOfChart = this.chartTitle.length > chartConfig.legend.labelMaxCharacterSize ? this.chartTitle.slice(0, chartConfig.legend.labelMaxCharacterSize) + '...' : this.chartTitle;
    return '<div class="d-flex flex-row" style="margin-top: 5px"><div style="background-size: 14px 14px;width: 14px;height: 14px;margin-top: 5px;margin-right: 0;" class="source-platform-image '
            + this.platformName
            + '-icon"></div><div class="title-text" style="color:#95A0B1;font-family:QuicksandSemibold, Arial, Helvetica, sans-serif;padding-top: 5px;font-size: 1.2rem;text-transform: none;">'
            + titleOfChart + '</div></div>';
  }

  private getConfigValue(configValue, defaultValue): any {
    if (configValue === null || configValue === undefined) {
      return defaultValue;
    }

    return configValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-circle-chart/achoo-gauge-circle-chart.component.ts